module.exports = __webpack_public_path__ + "img/logo_en.b2735655.svg";